import {
  ColumnSortEnum,
  TableStateWithFilters,
} from "@king-ict/eupisi-ui/components";

import { InstitutionSearch, InstitutionSort } from "../../models";
import { ClaimType, UserPermission } from "../../models/User";
import { TableUtils } from "../../utils";

export const createInitialInstitutionSearch = (
  currentRole: UserPermission | undefined,
  initialTableState: TableStateWithFilters<InstitutionSearch>,
  defaultInstitutionIds: number[]
): InstitutionSearch => {
  return {
    countyId:
      currentRole?.claimType === ClaimType.County &&
      currentRole.locations &&
      currentRole.locations.length > 0
        ? currentRole.locations[0]
        : undefined,
    townIds: initialTableState.townIds,
    institutionIds: initialTableState.institutionIds
      ? initialTableState.institutionIds
      : defaultInstitutionIds,
    programIds: initialTableState.programIds,
    excludeHandicapped: initialTableState.excludeHandicapped,
    excludeSatellite: initialTableState.excludeSatellite,
    isMinority: false,
    isReligious: false,
  };
};

export const createInitialTableState = (storageKey: string) => {
  return TableUtils.CreateInitialTableState<InstitutionSearch>(
    storageKey,
    TableUtils.tableDefaultState(
      InstitutionSort.Institution,
      ColumnSortEnum.ASC
    )
  );
};

export const isInstitutionClaimType = (claimType?: ClaimType) => {
  return [ClaimType.Institution, ClaimType.TownOffice].includes(
    claimType ?? ClaimType.Institution
  );
};
